export const addCtaRefToUrl = (url, ctaRef) => {
  if (!url || !ctaRef) {
    return url;
  }

  const urlObj = new URL(url);
  urlObj.searchParams.set("ctaref", ctaRef);
  return urlObj.toString();
};

export const generateNavigationCtaRef = item => {
  const ctaName = item.label.toLowerCase().replace(":", "");
  const ctaLocation = item.linkType;

  return `${ctaName} - ${ctaLocation}`;
};
